import Vue from 'vue';
import VueI18n from 'vue-i18n';

import { getLang } from '@/helpers/language';

import * as index from '@/plugins/i18n_index.js';

Vue.use(VueI18n);

// Ready translated locale messages
let messages = {
  ko: {},
  en: {},
};

const keys = Object.keys(index);
for (let i = 0; i < keys.length; i++) {
  const key = keys[i];
  const el = index[keys[i]];

  messages.ko[key] = el.ko;
  messages.en[key] = el.en;
}

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: getLang(),
  fallbackLocale: 'en',
  messages,
});

export default i18n;
